module.exports = __webpack_public_path__ + "img/mosque.c48632f8.svg";